import { getDaysDifferenceBetweenDates } from '../../utilities/dateHelper';
import { applicationStatus } from './constant';

export const getformattedApplicationForCSV = ({ list }) => {
  try {
    return list.map((data, index) => {
      const isPending = data.status === applicationStatus.PENDING;

      const pendingDays = getDaysDifferenceBetweenDates({
        date1: new Date(),
        date2: data?.createdAt
      });

      const passChecks = ({ field }) => {
        return field ? field.toString() : '-';
      };

      return {
        index: passChecks({ field: index + 1 }),
        fullName: passChecks({ field: data?.fullName }),
        email: passChecks({ field: data?.email }),
        status: passChecks({ field: data?.status }),
        pendingDays: isPending ? `${pendingDays} days` : '-',
        about: passChecks({ field: data?.about }),
        smLink: passChecks({ field: data?.primarySocialNetwork }),
        contactMethod: passChecks({ field: data?.contactMethod }),
        launchTime: passChecks({ field: data?.launchTime }),
        platform: passChecks({ field: data?.platform }),
        statusUpdatedAt: passChecks({ field: data?.updatedAt }),
        reviewerNotes: passChecks({ field: data?.reviewerNotes }),
        isCommunitySetup: passChecks({ field: data?.isCommunitySetup }),
        country: passChecks({ field: data?.country }),
        followersCount: passChecks({ field: data?.totalFollowers }),
        trackingData: passChecks({ field: data?.trackingData?.fromPage })
      };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const isInternalEmail = ({ email }) => {
  try {
    const emailDomain = email.split('@')[1];
    const internalDomains = [
      'nasacademy.com',
      'nasdaily.com',
      'nas.io',
      'thenasacademy.com'
    ];

    return internalDomains.includes(emailDomain);
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const getCancellationData = ({ application }) => {
  try {
    const subscriptions = application?.subscriptions;

    if (!subscriptions) return null;

    const applicationCode = application?.communityCode;

    const reqSubscription = subscriptions?.find(
      (sub) => sub?.communityCode === applicationCode
    );

    if (!reqSubscription) return null;

    return {
      isCancelled: reqSubscription?.status === 'Cancelled',
      cancellationReason: reqSubscription?.cancellationReason
    };
  } catch {
    return null;
  }
};
